
export * from '../../frontend-icons-web/__liferay__/index.js';
